import { MainLayout } from '@design-system/Layout';
import {
  getSellersProduct,
  getSellersLocations,
  getSellersProducts,
  getLoading,
  getPartnerLoading,
  getCart,
  getDeliveryLocation,
} from './redux/selectors';
import { useSelector, useDispatch } from 'react-redux';
import {
  get_sellers_locations,
  get_products,
  get_product,
  add_product_to_cart,
  get_cart,
  select_delivery_location,
  get_location,
} from './redux/reducer';
import {
  Body,
  DeliveryLocationList,
  DeliveryLocation,
  TopContainer,
  SelectionContainer,
  ProductContainer,
  SliderHeader,
  TotalPrice,
} from './style';
import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getUser } from '@app/auth/redux/selectors';
import { getSellerId, getSellers } from '@app/sellers/redux/selectors';
import { get_partner_id, get_sellers } from '@app/sellers/redux/reducer';
import commaNumber from 'comma-number';
import left from '@design-system/Assets/left.png';
import right from '@design-system/Assets/right.png';
import Skeleton from 'react-loading-skeleton';
import LocationLoader from '@design-system/Loaders/locationLoader';
import ProductLoader from '@design-system/Loaders/productLoader';
import Tooltip from '@design-system/tooltip';
import { CartButton } from '@design-system/CartButton';
import { add_product, get_logged_in_cart } from '@app/basket/redux/reducer';
import { getLoggedInCart } from '@app/basket/redux/selectors';
import { BiArrowBack } from 'react-icons/bi';

const Product = () => {
  const locations = useSelector(getSellersLocations);
  const products = useSelector(getSellersProducts);
  const product = useSelector(getSellersProduct);
  const user = useSelector(getUser);
  const [quantity, setQuantity] = useState(1);
  const [size, setSize] = useState(0);
  const params = useParams();
  const dispatch = useDispatch();
  const seller = useSelector(getSellers);
  const [activeImage, setActiveImage] = useState('');
  const loading = useSelector(getLoading);
  const sliderRef = useRef(null);
  const loading_info = useSelector(getPartnerLoading);
  const delivery_location = useSelector(getDeliveryLocation);
  const [isLocationExisting, setIsLocationExisting] = useState(false);
  const token = localStorage.getItem('x-access-token');
  const cart = token ? useSelector(getLoggedInCart) : useSelector(getCart);
  const [total, setTotal] = useState(0);
  const [max, setMax] = useState(10);
  const partner = useSelector(getSellerId);
  const [priceBasedOnPrice, setPriceBasedOnPrice] = useState(0);

  useEffect(() => {
    dispatch(get_location());
  }, [dispatch]);

  useEffect(() => {
    dispatch(get_partner_id(product?.owner?.business_name));
  }, [product]);

  useEffect(() => {
    dispatch(get_cart(partner));
    dispatch(get_logged_in_cart(partner));
  }, [dispatch, partner]);

  useEffect(() => {
    if (Object.keys(delivery_location).length >= 1) {
      const isExisting = locations?.some(
        (location) => location.location === delivery_location.location,
      );
      setIsLocationExisting(isExisting);
    }
  }, [delivery_location, locations]);

  useEffect(() => {
    dispatch(get_product(params.id));
  }, [dispatch, params]);

  useEffect(() => {
    if (product !== null && Object.keys(product).length !== 0) {
      dispatch(get_sellers_locations(product?.owner?._id));
      dispatch(get_sellers(product?.owner?._id));
      setActiveImage(product?.image);
    }
  }, [dispatch, product]);

  useEffect(() => {
    if (product?.owner?._id) {
      const categories = product?.product_category?.map((category) => category._id);

      categories?.forEach((category) => {
        dispatch(get_products({ id: product?.owner?._id, filter: category }));
      });
    }
  }, [product]);

  useEffect(() => {
    if (product) {
      setPriceBasedOnPrice(product?.price?.value);
    }
  }, [product]);

  useEffect(() => {
    const total = priceBasedOnPrice * quantity;
    setTotal(total);
  }, [priceBasedOnPrice, quantity]);

  const addProductToCart = () => {
    if (token) {
      let data = {
        partner: product?.owner?._id,
        user: user._id,
        products: [
          {
            product: product._id,
            quantity: parseInt(quantity) || 1,
            size: size || 1,
          },
        ],
      };
      dispatch(add_product(data));
    } else {
      const timestamp = new Date().getTime().toString(36);
      const randomNum = Math.random().toString(36).substr(2, 5);
      const id = timestamp + randomNum;
      let data = {
        ...product,
        partner: product?.owner?._id,
        user: user._id,
        product_id: id,
        quantity: parseInt(quantity) || 1,
        size: size || 1,
      };
      dispatch(add_product_to_cart(data));
    }
  };

  const handleImage = (data) => {
    setActiveImage(data);
  };

  const handleSlider = (direction) => {
    const container = sliderRef.current;

    if (container) {
      if (direction === 'left') {
        container.scrollLeft -= 100;
      } else if (direction === 'right') {
        container.scrollLeft += 100;
      }
    }
  };

  const selectLocation = (doc) => {
    dispatch(select_delivery_location(doc));
  };

  const handleSize = (event) => {
    const doc = JSON.parse(event.target.value);
    const { idx, size } = doc;
    setSize(idx);
    setMax(size?.quantity);
    setPriceBasedOnPrice(size?.price?.value);
  };

  return (
    <MainLayout>
      <Body>
        {cart?.length >= 1 && (
          <Link to="/basket">
            <CartButton />
          </Link>
        )}
        <div className="upper">
          {loading ? (
            <Skeleton width={100} height={10} />
          ) : (
            <Link to={`/sella/${product?.owner?.business_name}`} className="link">
              <BiArrowBack />

              {product?.owner?.business_name}
            </Link>
          )}

          <p>{'>'}</p>
          {loading ? (
            <Skeleton width={100} height={10} />
          ) : (
            <p className="p_name">{product?.name}</p>
          )}
        </div>
        <TopContainer>
          <div className="product_image">
            {loading ? (
              <div className="other_images">
                {[
                  ...new Array(4).map((_, idx) => (
                    <Skeleton key={idx} className="others" />
                  )),
                ]}
              </div>
            ) : (
              <div className="other_images">
                {product?.other_images?.map((data, indx) => (
                  <img
                    key={indx}
                    src={data}
                    alt={product?.name}
                    onClick={() => handleImage(data)}
                    className={activeImage === data ? 'active' : 'others'}
                  />
                ))}
                <img
                  src={product?.image}
                  alt={product?.name}
                  onClick={() => handleImage(product?.image)}
                  className={activeImage === product?.image ? 'active' : 'others'}
                />
              </div>
            )}

            {loading ? (
              <Skeleton className="main_image" />
            ) : (
              <img src={activeImage} alt={product?.name} className="main_image" />
            )}
          </div>

          <div>
            {loading ? (
              <Skeleton width={200} height={40} />
            ) : (
              <div className="product_name">{product?.name}</div>
            )}

            {loading ? (
              <Skeleton width={250} height={20} style={{ marginBottom: '55px' }} />
            ) : (
              <div className="product_price">
                {`From ${seller?.currency?.symbol}`}
                <strong>{commaNumber(product?.price?.value)}</strong>
              </div>
            )}

            {loading ? (
              <Skeleton width={250} height={30} />
            ) : (
              <div className="product_description">{product?.description}</div>
            )}

            <SelectionContainer>
              <div className="size">
                <label>Choose your size</label>

                {loading ? (
                  <Skeleton
                    style={{ width: '100%', height: '48px', marginTop: '8px' }}
                  />
                ) : (
                  <select name="quantity" onChange={handleSize}>
                    <option value="" disabled selected>
                      Select Size
                    </option>
                    {product?.sizes?.length <= 0 && <option value={1}> 1</option>}
                    {product?.sizes?.map((size, index) => {
                      const idx = index + 1;
                      const sizeWithIndex = { size, idx };
                      const value = JSON.stringify(sizeWithIndex);

                      return (
                        <option key={size.id} value={value}>
                          {`${size.weight} ${product?.unit} - ${commaNumber(
                            size.price.value,
                          )}`}
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>

              <div className="quantity_container">
                <label> Quantity </label>
                {loading ? (
                  <Skeleton className="quantity" style={{ height: '48px' }} />
                ) : (
                  <select
                    className="quantity"
                    name="quantity"
                    onChange={(e) => setQuantity(e.target.value)}
                    max={max}
                  >
                    <option value="" selected disabled>
                      Select Quantity
                    </option>
                    {Array.from({ length: max }, (_, index) => (
                      <option key={index + 1} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </SelectionContainer>

            <TotalPrice>Total Price: {commaNumber(total)}</TotalPrice>

            <p className="product_delivery">Delivery Region</p>
            {/* Add a .map here */}
            {loading_info ? (
              <DeliveryLocation>
                {[...new Array(5)].map((_, idx) => (
                  <LocationLoader key={idx} />
                ))}
              </DeliveryLocation>
            ) : (
              <DeliveryLocation style={{ marginTop: 8 }}>
                {locations?.map((data) => (
                  <div key={data?._id} onClick={() => selectLocation(data)}>
                    <Tooltip content={data} position={'top'}>
                      <DeliveryLocationList
                        selected={data?.location === delivery_location.location}
                      >
                        {data?.location}
                      </DeliveryLocationList>
                    </Tooltip>
                  </div>
                ))}
              </DeliveryLocation>
            )}
            {!isLocationExisting ? (
              <p style={{ color: 'red', textAlign: 'center' }}>
                Please select a delivery region
              </p>
            ) : null}

            <button
              className="btn"
              onClick={() => addProductToCart()}
              style={{ cursor: 'pointer' }}
              disabled={!isLocationExisting}
            >
              Add To Cart
            </button>
          </div>
        </TopContainer>

        <SliderHeader>
          <h5>Similar Items</h5>
          <aside>
            <button onClick={() => handleSlider('left')}>
              <img src={left} alt="left-arrow" />
            </button>
            <button onClick={() => handleSlider('right')}>
              <img src={right} alt="right-arrow" />
            </button>
          </aside>
        </SliderHeader>

        {loading_info ? (
          <ProductLoader />
        ) : (
          <ProductContainer ref={sliderRef}>
            {products?.map((product) => (
              <Link
                to={`/products/${product._id}`}
                key={product?._id}
                style={{ textDecoration: 'none' }}
              >
                <div className="card">
                  <img src={product?.image} />
                  <div className="product_name">{product.name}</div>
                  <div className="product_price">
                    From {seller?.currency?.symbol}
                    <strong>{commaNumber(product?.price?.value)}</strong>
                  </div>
                </div>
              </Link>
            ))}
          </ProductContainer>
        )}
      </Body>
    </MainLayout>
  );
};

export default Product;
